import Box from "@mui/material/Box";

interface IDPieChart {
    amount: number;
    size?: string;
    color?: string;
    bgColor?: string;
}

const PieChart = ({amount, size = "small", color = "", bgColor = ""}: IDPieChart) => {

    return (
        <Box
            color="secondary.light"
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{
                color: color !== "" ? color : "secondary.light",
                width: size === "big" ? 36 : 30,
                height: size === "big" ? 36 : 30,
                fontSize: size === "big" ? "1.2rem" : "1rem",
                lineHeight: 1,
                borderRadius: "50%",
                border: bgColor !== "" ? `1px solid ${bgColor}` : "1px solid #fff",
                background: bgColor !== "" ? `conic-gradient(${bgColor} ${amount}%, #0000 0)` : `conic-gradient(#ffffff ${amount}%, #0000 0)`,
            }}
        >
            {amount}
        </Box>
    );
};

export default PieChart;
